import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { AuthModal } from "../../../models/AuthModal";
import { CollectionPickerModal } from "../../Collections/CollectionPickerModal";
import CollectionCreateModal from "../../Collections/CollectionCreateModal";
import { CurrencySymbol } from "../../../utils/enums";

export default function HousePropertySlider({ e, savedLocalPost }) {
  const navigate = useNavigate();
  const [authPopUp, setAuthPopUp] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const isAuthenticate = !!localStorage.getItem("Token");

  const handleFavoriteClick = (ev) => {
    ev.stopPropagation();
    if (!isAuthenticate) {
      setAuthPopUp(true);
      return;
    }
    setPickerOpen(true);
  };

  const modalRoot =
    typeof document !== "undefined" ? document.body : null;

  return (
    <>
      <div
        className="bg-white max-w rounded-2xl overflow-hidden border-[1.5px] border-[#EAEAEA] transition-all duration-300 cursor-pointer"
        onClick={() => navigate(`/property-house/${e?.id}`)}
      >
        {/* 🔹 Property Image */}
        <div className="relative">
          <img
            src={e?.clientImage?.[0]}
            alt="property"
            className="w-full h-56 object-cover"
          />
        </div>

        {/* 🔹 Card Body */}
        <div className="p-4 flex flex-col ">
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
              {/* Price */}
              <h3 className="text-blue-600 text-2xl font-bold">{CurrencySymbol.NGN} {String(e?.price).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>

              {/* Title */}
              <h2 className="text-lg xl:text-xl font-semibold text-gray-800 mt-1 truncate w-44  xl:w-60">
                {e?.head}
              </h2>
            </div>
            {/* Heart Icon */}
            <button
              type="button"
              className="p-3 rounded-full border-[1.5px] border-[#EAEAEA] "
              onClick={handleFavoriteClick}
              aria-label="Save to collection"
            >
              {isAuthenticate && e?.collections?.length > 0 ? (
                <FaHeart color="#097FE6" size={20} />
              ) : (
                <FiHeart color="#097FE6" size={20} />
              )}
            </button>
          </div>
          {/* Address */}
          <div className="flex items-center gap-2 text-gray-500 text-base mt-3 h-10 truncate w-[95%]">
            <p className="line-clamp-1 truncate">{e?.place}</p>
          </div>
          <div>
            {/* Divider */}
            <div className="border-t my-3"></div>

            {/* Features */}
            <div className="flex items-center justify-between text-sm xl:text-base gap-6 text-[#000929] ">
              {e?.iconWithCount?.map((elm, ind) => (
                <div key={ind} className="flex items-center gap-1">
                  <img src={elm?.icon} alt="" className="w-4" />
                  <span>{elm?.count}</span>
                  <span>{elm?.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {modalRoot
        ? createPortal(
          <>
            <CollectionPickerModal
              open={pickerOpen}
              onClose={() => setPickerOpen(false)}
              propertyId={e?.id}
              initialSelectedIds={
                e?.collections?.map(
                  (col) => col.id ?? col._id ?? col.collectionId,
                ) || []
              }
              onCreateNewCollection={() => setCreateModalOpen(true)}
            />
            {createModalOpen && (
              <CollectionCreateModal
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
                editingCollection={null}
                onSaved={() => { }}
              />
            )}
            {authPopUp && (
              <AuthModal
                open={authPopUp}
                onClose={() => setAuthPopUp(false)}
              />
            )}
          </>,
          modalRoot,
        )
        : null}
    </>
  );
}
